export const constants = {
  baseUrl: "https://berger-greet-api.appswind.com/v1",
};
